/**
 * Lightweight Zustand store for transport live-collection state.
 *
 * When a transport session is active, map clicks are routed here so the
 * TransportNetworkPanel can log them as stops without needing prop drilling.
 */

import { create } from 'zustand';

interface TransportStore {
  /** Currently active collection session ID, null if no session */
  activeSessionId: number | null;
  setActiveSession: (id: number | null) => void;

  /** Callback registered by TransportNetworkPanel to receive map-click coords */
  onMapClick: ((lat: number, lng: number) => void) | null;
  registerMapClickHandler: (handler: ((lat: number, lng: number) => void) | null) => void;
}

export const useTransportStore = create<TransportStore>((set) => ({
  activeSessionId: null,
  setActiveSession: (id) => set({ activeSessionId: id }),

  onMapClick: null,
  registerMapClickHandler: (handler) => set({ onMapClick: handler }),
}));
